import React, { useState, useEffect } from 'react';
import './index.scss';
import api from '../../../api.js';
import Rodape from '../../../components/Rodape/index.js';
import MenuLateral from '../../../components/MenuLateral/index.js';
import Cabecalho from '../../../components/Cabecalho/index.js';
import { useAuth } from '../../../context/AuthContext.js';
import { useToast } from '../../../context/ToastContext.js';
import CurrencyInput from 'react-currency-input-field';

export default function Admin() {
    const { nivelAcesso } = useAuth();
    const { showToast } = useToast();
    const [statusAtualBD, setStatusAtualBD] = useState('online'); // Status real do BD
    const [statusSite, setStatusSite] = useState('online'); // Status sendo editado
    const [motivoManutencao, setMotivoManutencao] = useState('');
    const [bloqueioCadastros, setBloqueioCadastros] = useState(false);
    const [bloqueioPedidos, setBloqueioPedidos] = useState(false);
    const [whatsappHabilitado, setWhatsappHabilitado] = useState(true);
    const [whatsappNumero, setWhatsappNumero] = useState('5511997636154');
    const [emailAlertaHabilitado, setEmailAlertaHabilitado] = useState(true);
    const [retiradaNaLojaHabilitada, setRetiradaNaLojaHabilitada] = useState(true);
    const [limiteFreteGratis, setLimiteFreteGratis] = useState(200);
    const [valorEntregaPadrao, setValorEntregaPadrao] = useState(15);
    const [estadisticas, setEstadisticas] = useState({
        totalUsuarios: 0,
        totalPedidos: 0,
        totalProdutos: 0,
        pedidosHoje: 0
    });
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingEmail, setLoadingEmail] = useState({});
    const [emailDestino, setEmailDestino] = useState('');

    const formatarWhatsappInput = (valor) => {
        const digitos = String(valor || '').replace(/\D/g, '').slice(0, 20);

        if (!digitos) return '';
        if (digitos.length <= 2) return `+${digitos}`;
        if (digitos.length <= 4) return `+${digitos.slice(0, 2)} (${digitos.slice(2)}`;
        if (digitos.length <= 9) {
            return `+${digitos.slice(0, 2)} (${digitos.slice(2, 4)}) ${digitos.slice(4)}`;
        }

        return `+${digitos.slice(0, 2)} (${digitos.slice(2, 4)}) ${digitos.slice(4, 9)}-${digitos.slice(9)}`;
    };

    useEffect(() => {
        if (nivelAcesso !== 'Administrador') {
            window.location.href = '/';
            return;
        }
        carregarDados();
    }, [nivelAcesso]);

    const carregarDados = async () => {
        setLoading(true);
        try {
            const resposta = await api.get('/api/admin/dashboard', { withCredentials: true });
            setEstadisticas(resposta.data.estatisticas || {
                totalUsuarios: 0,
                totalPedidos: 0,
                totalProdutos: 0,
                pedidosHoje: 0
            });
            const statusBD = resposta.data.statusSite || 'online';
            setStatusAtualBD(statusBD); // Status real do BD
            setStatusSite(statusBD); // Status para edição
            setMotivoManutencao(resposta.data.motivoManutencao || '');
            setBloqueioCadastros(Boolean(resposta.data.bloqueioCadastros));
            setBloqueioPedidos(Boolean(resposta.data.bloqueioPedidos));
            setWhatsappHabilitado(Boolean(resposta.data.whatsappHabilitado));
            setWhatsappNumero(resposta.data.whatsappNumero || '5511997636154');
            setEmailAlertaHabilitado(Boolean(resposta.data.emailAlertaHabilitado !== false));
            setRetiradaNaLojaHabilitada(Boolean(resposta.data.retiradaNaLojaHabilitada !== false));
            setLimiteFreteGratis(Number(resposta.data.limiteFreteGratis || 200));
            setValorEntregaPadrao(Number(resposta.data.valorEntregaPadrao || 15));
            setLogs(resposta.data.logs || []);
        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            // Usar dados padrão em caso de erro
            setEstadisticas({
                totalUsuarios: 0,
                totalPedidos: 0,
                totalProdutos: 0,
                pedidosHoje: 0
            });
        } finally {
            setLoading(false);
        }
    };

    const atualizarStatusSite = async () => {
        try {
            await api.put('/api/admin/status-site', {
                status: statusSite,
                motivo: motivoManutencao,
                bloqueio_cadastros: bloqueioCadastros,
                bloqueio_pedidos: bloqueioPedidos,
                whatsapp_habilitado: whatsappHabilitado,
                whatsapp_numero: whatsappNumero,
                email_alerta_habilitado: emailAlertaHabilitado,
                retirada_na_loja_habilitada: retiradaNaLojaHabilitada,
                limite_frete_gratis: limiteFreteGratis,
                valor_entrega_padrao: valorEntregaPadrao
            }, { withCredentials: true });
            showToast('Alterações salvas com sucesso!', 'success');
            // Recarregar dados para confirmar a atualização
            await carregarDados();
        } catch (error) {
            console.error('Erro ao atualizar status:', error);
            showToast('Erro ao atualizar status. Verifique se as tabelas foram criadas no banco de dados.', 'error');
        }
    };

    const testarEmail = async (tipo) => {
        if (!emailDestino || !emailDestino.includes('@')) {
            showToast('Informe um email de destino válido antes de testar.', 'error');
            return;
        }
        setLoadingEmail(prev => ({ ...prev, [tipo]: true }));
        try {
            await api.post('/api/admin/testar-email', { tipo, email_destino: emailDestino }, { withCredentials: true });
            showToast(`Email de teste "${tipo}" enviado para ${emailDestino}!`, 'success');
        } catch (error) {
            const msg = error?.response?.data?.message || 'Erro ao enviar email de teste.';
            showToast(msg, 'error');
        } finally {
            setLoadingEmail(prev => ({ ...prev, [tipo]: false }));
        }
    };

    const exportarRelatorio = async () => {        try {
            const resposta = await api.get('/api/admin/relatorio', {
                withCredentials: true
            });

            // Criar um relatório em texto formatado
            const dados = resposta.data.relatorio;
            const conteudo = `
RELATÓRIO FRACARO STORE
Data: ${dados.data}

=================================
VENDAS DO ÚLTIMO MÊS
=================================
Total de Vendas: R$ ${dados.vendas.total || 0}
Quantidade de Pedidos: ${dados.vendas.quantidade || 0}

=================================
CLIENTES ATIVOS
=================================
Total de Clientes: ${dados.clientes.total || 0}

=================================
PRODUTOS MAIS VENDIDOS (TOP 10)
=================================
${dados.produtosTopo.map((p, i) => `${i + 1}. ${p.nome} - ${p.quantidade_vendida} unidades`).join('\n')}
            `;

            const blob = new Blob([conteudo], { type: 'text/plain' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `relatorio-${new Date().toISOString().split('T')[0]}.txt`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erro ao exportar relatório:', error);
        }
    };

    return (
        <section className='container-principal-admin'>
            <Cabecalho />
            <main className='main-admin'>
                <MenuLateral />
                <section className='conteudo-admin'>
                    <div className='titulo-admin'>
                        <h1>Painel de Administração</h1>
                        <span>Controle total do site Fracaro Store</span>
                    </div>

                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando painel...</h2>
                        </div>
                    ) : (
                    <>
                    {/* ESTATÍSTICAS */}
                    <div className='cards-estatisticas'>
                        <div className='card-stat'>
                            <h3>Total de Usuários</h3>
                            <p className='valor'>{estadisticas.totalUsuarios}</p>
                        </div>

                        <div className='card-stat'>
                            <h3>Total de Pedidos</h3>
                            <p className='valor'>{estadisticas.totalPedidos}</p>
                        </div>

                        <div className='card-stat'>
                            <h3>Total de Produtos</h3>
                            <p className='valor'>{estadisticas.totalProdutos}</p>
                        </div>

                        <div className='card-stat'>
                            <h3>Pedidos Hoje</h3>
                            <p className='valor'>{estadisticas.pedidosHoje}</p>
                        </div>
                    </div>

                    {/* MANUTENÇÃO */}
                    <div className='card-manutencao'>
                        <div className='cabecalho-manutencao'>
                            <p>Controle de Manutenção</p>
                            <div style={{ backgroundColor: statusAtualBD === 'online' ? '#4CAF50' : '#FF9800' }}><strong>
                                {statusAtualBD === 'online' ? ' Online' : ' Em Manutenção'}  </strong></div>
                        </div>
                        <div className='container-interno'>
                            <div className='status-container'>
                                <div className='radio-group'>
                                    <label className='radio-option'>
                                        <input
                                            type='radio'
                                            value='online'
                                            checked={statusSite === 'online'}
                                            onChange={(e) => setStatusSite(e.target.value)}
                                        />
                                        <span className='radio-circle online'></span>
                                        Online
                                    </label>
                                    <label className='radio-option'>
                                        <input
                                            type='radio'
                                            value='manutencao'
                                            checked={statusSite === 'manutencao'}
                                            onChange={(e) => setStatusSite(e.target.value)}
                                        />
                                        <span className='radio-circle manutencao'></span>
                                        Em Manutenção
                                    </label>
                                </div>
                            </div>

                            {statusSite === 'manutencao' && (
                                <div className='motivo-manutencao'>
                                    <label htmlFor='motivo'>Motivo da Manutenção</label>
                                    <textarea
                                        id='motivo'
                                        value={motivoManutencao}
                                        onChange={(e) => setMotivoManutencao(e.target.value)}
                                        placeholder='Ex: Atualizações do sistema, melhorias de segurança...'
                                        maxLength={500}
                                    />
                                    <p className='contador'>{motivoManutencao.length}/500</p>
                                </div>
                            )}

                            <div className='info-manutencao'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9 15H11V17H9V15ZM9 5H11V13H9V5Z" fill="#F57C00" />
                                </svg>
                                <p>Quando o site está em manutenção, apenas administradores poderão acessá-lo. Os clientes verão uma página de manutenção com o motivo informado.</p>
                            </div>

                            <button className='btn-salvar' onClick={atualizarStatusSite}>
                                Salvar Alterações
                            </button>
                        </div>
                    </div>

                    {/* BLOQUEIOS */}
                    <div className='card-bloqueios'>
                        <div className='cabecalho-bloqueios'>
                            <p>Bloqueios e Canais</p>
                        </div>
                        <div className='container-interno'>
                            <label className='toggle-option'>
                                <input
                                    type='checkbox'
                                    checked={bloqueioCadastros}
                                    onChange={(e) => setBloqueioCadastros(e.target.checked)}
                                />
                                <span>Bloquear novos cadastros</span>
                            </label>
                            <label className='toggle-option'>
                                <input
                                    type='checkbox'
                                    checked={bloqueioPedidos}
                                    onChange={(e) => setBloqueioPedidos(e.target.checked)}
                                />
                                <span>Bloquear novos pedidos</span>
                            </label>
                            <label className='toggle-option'>
                                <input
                                    type='checkbox'
                                    checked={whatsappHabilitado}
                                    onChange={(e) => setWhatsappHabilitado(e.target.checked)}
                                />
                                <span>Exibir botão flutuante do WhatsApp</span>
                            </label>
                            <label className='toggle-option'>
                                <input
                                    type='checkbox'
                                    checked={emailAlertaHabilitado}
                                    onChange={(e) => setEmailAlertaHabilitado(e.target.checked)}
                                />
                                <span>Habilitar alertas de email</span>
                            </label>
                            <div className='motivo-manutencao'>
                                <label htmlFor='numero_whatsapp'>Número WhatsApp (somente dígitos)</label>
                                <input
                                    id='numero_whatsapp'
                                    className='input-whatsapp-admin'
                                    type='tel'
                                    inputMode='numeric'
                                    autoComplete='off'
                                    value={formatarWhatsappInput(whatsappNumero)}
                                    onChange={(e) => setWhatsappNumero(e.target.value.replace(/\D/g, '').slice(0, 20))}
                                    placeholder='Ex: 5511997636154'
                                />
                            </div>
                            <button className='btn-salvar' onClick={atualizarStatusSite}>
                                Salvar Alterações
                            </button>
                        </div>
                    </div>

                    <div className='card-config-frete'>
                        <div className='cabecalho-config-frete'>
                            <p>Configurações de frete</p>
                        </div>
                        <div className='container-interno'>
                            <div className='motivo-manutencao'>
                                <label htmlFor='limite_frete_gratis'>Valor limite para frete grátis</label>
                                <CurrencyInput
                                    id='limite_frete_gratis'
                                    className='input-whatsapp-admin'
                                    prefix='R$ '
                                    decimalSeparator=','
                                    groupSeparator='.'
                                    decimalsLimit={2}
                                    allowNegativeValue={false}
                                    value={limiteFreteGratis}
                                    onValueChange={(value) => setLimiteFreteGratis(Math.max(Number(value || 0), 0))}
                                    placeholder='R$ 0,00'
                                />
                            </div>

                            <div className='motivo-manutencao'>
                                <label htmlFor='valor_entrega_padrao'>Preço de envio abaixo do limite</label>
                                <CurrencyInput
                                    id='valor_entrega_padrao'
                                    className='input-whatsapp-admin'
                                    prefix='R$ '
                                    decimalSeparator=','
                                    groupSeparator='.'
                                    decimalsLimit={2}
                                    allowNegativeValue={false}
                                    value={valorEntregaPadrao}
                                    onValueChange={(value) => setValorEntregaPadrao(Math.max(Number(value || 0), 0))}
                                    placeholder='R$ 0,00'
                                />
                            </div>

                            <label className='toggle-option'>
                                <input
                                    type='checkbox'
                                    checked={retiradaNaLojaHabilitada}
                                    onChange={(e) => setRetiradaNaLojaHabilitada(e.target.checked)}
                                />
                                <span>Habilitar retirada na loja</span>
                            </label>

                            <button className='btn-salvar' onClick={atualizarStatusSite}>
                                Salvar Alterações
                            </button>
                        </div>
                    </div>

                    {/* TESTES DE EMAIL */}
                    <div className='card-teste-email'>
                        <div className='cabecalho-teste-email'>
                            <p>Testes de Email</p>
                            <span>Ambiente de testes - envia emails reais para o endereço informado</span>
                        </div>
                        <div className='container-interno'>
                            <div className='motivo-manutencao'>
                                <label htmlFor='email_destino_teste'>Email de destino para os testes</label>
                                <input
                                    id='email_destino_teste'
                                    className='input-whatsapp-admin'
                                    type='email'
                                    value={emailDestino}
                                    onChange={(e) => setEmailDestino(e.target.value)}
                                    placeholder='seu@email.com'
                                />
                            </div>
                            <div className='botoes-teste-email'>
                                <button
                                    className='btn-teste-email'
                                    onClick={() => testarEmail('confirmacaoPedido')}
                                    disabled={loadingEmail['confirmacaoPedido']}
                                >
                                    {loadingEmail['confirmacaoPedido'] ? 'Enviando...' : '📦 Pedido Confirmado (com itens)'}
                                </button>
                                <button
                                    className='btn-teste-email'
                                    onClick={() => testarEmail('pedidoPago')}
                                    disabled={loadingEmail['pedidoPago']}
                                >
                                    {loadingEmail['pedidoPago'] ? 'Enviando...' : '💳 Pagamento Confirmado'}
                                </button>
                                <button
                                    className='btn-teste-email'
                                    onClick={() => testarEmail('mudancaStatus')}
                                    disabled={loadingEmail['mudancaStatus']}
                                >
                                    {loadingEmail['mudancaStatus'] ? 'Enviando...' : '🚚 Mudança de Status (Enviado)'}
                                </button>
                                <button
                                    className='btn-teste-email'
                                    onClick={() => testarEmail('boasVindas')}
                                    disabled={loadingEmail['boasVindas']}
                                >
                                    {loadingEmail['boasVindas'] ? 'Enviando...' : '🎉 Boas-vindas (Novo Cadastro)'}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* LOGS */}
                    <div className='conteudo-logs'>
                        <div className='cabecalho-logs'>
                            <h3>Logs do Sistema</h3>
                        </div>
                        <div className='container-interno-logs'>
                            {logs.length === 0 ? (
                                <div className='sem-logs'>
                                    <p>Nenhum log registrado</p>
                                </div>
                            ) : (
                                <div className='tabela-logs'>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Data/Hora</th>
                                                <th>Tipo</th>
                                                <th>Usuário</th>
                                                <th>Ação</th>
                                                <th>Descrição</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {logs.map((log, index) => (
                                                <tr key={index} className={`log-conteudo`}>
                                                    <td className="primeiro">{new Date(log.data).toLocaleString('pt-BR')}</td>
                                                    <td>
                                                        <span className={`badge badge-${log.tipo}`}>
                                                            {log.tipo}
                                                        </span>
                                                    </td>
                                                    <td>{log.usuario}</td>
                                                    <td className="final">{log.acao}</td>
                                                    <td>{log.descricao}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* RELATÓRIOS */}
                    <div className='relatorios-grid'>
                        <div className='card-relatorio'>
                            <div className='card-header-relatorio'>Vendas Mensais</div>
                            <div className='card-content-relatorio'>
                                <div className='icone-relatorio'>
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 2H28L38 12V38C38 39.1046 37.1046 40 36 40H10C8.89543 40 8 39.1046 8 38V2Z" fill="#E3F2FD" />
                                        <path d="M28 2V12H38" fill="#1976D2" />
                                    </svg>
                                </div>
                                <h3>Vendas Mensais</h3>
                                <p>Relatório completo de vendas do mês atual</p>
                                <button className='btn-download' onClick={exportarRelatorio}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 1V10M8 10L4 6M8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 14H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Exportar PDF
                                </button>
                            </div>
                        </div>

                        <div className='card-relatorio'>
                            <div className='card-header-relatorio'>Clientes Ativos</div>
                            <div className='card-content-relatorio'>
                                <div className='icone-relatorio'>
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 2H28L38 12V38C38 39.1046 37.1046 40 36 40H10C8.89543 40 8 39.1046 8 38V2Z" fill="#F3E5F5" />
                                        <path d="M28 2V12H38" fill="#7B1FA2" />
                                    </svg>
                                </div>
                                <h3>Clientes Ativos</h3>
                                <p>Lista de clientes que realizaram compras</p>
                                <button className='btn-download' onClick={exportarRelatorio}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 1V10M8 10L4 6M8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 14H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Exportar PDF
                                </button>
                            </div>
                        </div>

                        <div className='card-relatorio'>
                            <div className='card-header-relatorio'>Produtos Mais Vendidos</div>
                            <div className='card-content-relatorio'>
                                <div className='icone-relatorio'>
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 2H28L38 12V38C38 39.1046 37.1046 40 36 40H10C8.89543 40 8 39.1046 8 38V2Z" fill="#E8F5E9" />
                                        <path d="M28 2V12H38" fill="#2E7D32" />
                                    </svg>
                                </div>
                                <h3>Produtos Mais Vendidos</h3>
                                <p>Ranking dos produtos com melhor desempenho</p>
                                <button className='btn-download' onClick={exportarRelatorio}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 1V10M8 10L4 6M8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 14H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Exportar PDF
                                </button>
                            </div>
                        </div>

                        <div className='card-relatorio'>
                            <div className='card-header-relatorio'>Análise Financeira</div>
                            <div className='card-content-relatorio'>
                                <div className='icone-relatorio'>
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 2H28L38 12V38C38 39.1046 37.1046 40 36 40H10C8.89543 40 8 39.1046 8 38V2Z" fill="#FFF3E0" />
                                        <path d="M28 2V12H38" fill="#F57C00" />
                                    </svg>
                                </div>
                                <h3>Análise Financeira</h3>
                                <p>Demonstrativo de receitas e despesas</p>
                                <button className='btn-download' onClick={exportarRelatorio}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M8 1V10M8 10L4 6M8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 14H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Exportar PDF
                                </button>
                            </div>
                        </div>
                    </div>
                    </>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}
